import { render, staticRenderFns } from "./WrapperRanking.vue?vue&type=template&id=67f5001f&scoped=true"
import script from "./WrapperRanking.vue?vue&type=script&lang=ts"
export * from "./WrapperRanking.vue?vue&type=script&lang=ts"
import style0 from "./WrapperRanking.vue?vue&type=style&index=0&id=67f5001f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f5001f",
  null
  
)

export default component.exports